import { render, staticRenderFns } from "./TabDaily.vue?vue&type=template&id=465ebfa9"
import script from "./TabDaily.vue?vue&type=script&lang=js"
export * from "./TabDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports